import * as Yup from 'yup';

import { STATUSES } from 'constants/common';

import { getTranslation } from 'helpers/getTranslation';

export const getInitialValues = ({
  isSchool,
  schools,
  courses,
  currentSchoolId,
}: {
  isSchool: any;
  schools: any;
  courses: any;
  currentSchoolId: string;
}) => {
  const currentSchool = schools.find(
    (school: any) => school.id === currentSchoolId,
  );
  const isDefaultSchool = currentSchool
    ? currentSchool.name === 'Befront'
    : false;

  if (!isSchool) {
    return {
      email: '',
      firstName: '',
      lastName: '',
      school: '',
      courses: [],
      isTest: false,
      isAdmin: false,
    };
  }

  return {
    email: '',
    firstName: '',
    lastName: '',
    school: '',
    courses: isDefaultSchool
      ? courses
          .filter((course: any) => course.status === STATUSES.PUBLISHED)
          .map((course: any) => course.id)
      : [],
    isTest: false,
    isAdmin: false,
  };
};

export const getValidationSchema = ({
  isRootAdmin,
  isSchool,
}: {
  isRootAdmin: any;
  isSchool: any;
}) => {
  if (isRootAdmin && !isSchool) {
    return Yup.object().shape({
      school: Yup.object().required(
        getTranslation('components.add_student.validation.school'),
      ),
      email: Yup.string()
        .email(getTranslation('components.add_student.validation.email_type'))
        .required(getTranslation('components.add_student.validation.email')),
      firstName: Yup.string().ensure(),
      lastName: Yup.string().ensure(),
      courses: Yup.array().ensure(),
    });
  }

  return Yup.object().shape({
    email: Yup.string()
      .email(getTranslation('components.add_student.validation.email_type'))
      .required(getTranslation('components.add_student.validation.email')),
    firstName: Yup.string().ensure(),
    lastName: Yup.string().ensure(),
    courses: Yup.array().ensure(),
  });
};
